export const handleSignatureEnd = (setSignature, formData, setFormData, signature, sigRef) => {
  setSignature(sigRef.current.toDataURL());
  formData.Signature = signature;
  setFormData({ ...formData });
};

export const clearSignature = (sigRef, setSignature, formData, setFormData) => {
  sigRef.current.clear();
  setSignature((formData.Signature = ""));
  setFormData({ ...formData });
};